var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadexcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud_upload",
    clipPath: "url(#clip0_124_38551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.15 23.4268C43.5633 15.3768 36.4933 9.3335 28 9.3335C21.2567 9.3335 15.4 13.1602 12.4833 18.7602C5.46 19.5068 0 25.4568 0 32.6668C0 40.3902 6.27667 46.6668 14 46.6668H44.3333C50.7733 46.6668 56 41.4402 56 35.0002C56 28.8402 51.2167 23.8468 45.15 23.4268ZM32.6667 30.3335V39.6668H23.3333V30.3335H16.3333L28 18.6668L39.6667 30.3335H32.6667Z",
    fill: "#534FA1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_124_38551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadexcel);
export default __webpack_public_path__ + "static/media/uploadexcel.ccba79753137d5c201969c08e0d2064d.svg";
export { ForwardRef as ReactComponent };